<template>
    <div class="popup-container" id="popup-container">
        <v-toolbar dark color="primary">
            <v-toolbar-title class="heading-title">
                Edit Playlist
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn fab x-small class="close" @click="closePanel">
                <v-icon dark>fa-times</v-icon>
            </v-btn>
        </v-toolbar>
        <v-container class="assetbar">
            <v-row>
                <v-col md="12">
                    <v-form>
                        <v-text-field
                        :error-messages="messages.name"
                        v-model="channel.name"
                        label="Playlist Name"
                        type="text"
                        filled
                        >
                            <template slot="append-outer">
                                <v-tooltip left>
                                 <template v-slot:activator="{on}">
                                  <v-icon v-on="on">fa fa-question</v-icon>
                                 </template>
                                 <span>Enter Playlist Name</span>
                                </v-tooltip>
                            </template>
                        </v-text-field>
                        <v-textarea
                        v-model="channel.description"
                        label="Description"
                        hint="Enter a description for this playlist"
                        filled
                        >
                            <template slot="append-outer">
                                <v-tooltip left>
                                 <template v-slot:activator="{on}">
                                  <v-icon v-on="on">fa fa-question</v-icon>
                                 </template>
                                 <span>Enter a description for this playlist</span>
                                </v-tooltip>
                            </template>
                        </v-textarea>
                        <v-select
                        :error-messages="messages.thumbnail"
                        :items="ChannelOptions"
                        v-model="channel.thumbnailOption"
                        item-value="id"
                        item-text="name"
                        label="Thumbnail (Please choose either an icon or upload your own image)"
                        filled
                        attach
                        >
                            <template slot="append-outer">
                                <v-tooltip left>
                                 <template v-slot:activator="{on}">
                                  <v-icon v-on="on">fa fa-question</v-icon>
                                 </template>
                                 <span>Please choose either an icon or upload your own image</span>
                                </v-tooltip>
                            </template>
                        </v-select>
                    </v-form>
                </v-col>
            </v-row>
            <v-row v-if="channel.thumbnailOption == 'icon'">
                <v-col md="8">
                    <icon-picker />
                </v-col>
                <v-col md="4">
                    <i class="fa super-size-icon" :class="'fa-' + selectedIcon"></i>
                </v-col>
            </v-row>
            <v-row v-else>
                <v-col md="12">
                    <drop-zone
                    :type="type"
                    :accepted="accepted"
                    :image.sync="thumbnail"
                    class="mt-5 dropzone-container"
                    text="Click here to upload Playlist Image"
                    filled
                    :dropzone-id="'channel'"
                    ></drop-zone>
                    <label v-if="messages.s3_url"
                    :error-messages="messages.s3_url"
                    class="v-messages theme--light error--text">The image field is required.
                    </label>
                    <template>
                      <v-tooltip left>
                       <template v-slot:activator="{on}">
                        <v-icon v-on="on" class="dropzone-help">fa fa-question</v-icon>
                       </template>
                       <span>Upload Playlist Image</span>
                      </v-tooltip>
                    </template>
                    <p class="block text-left mt-4 caption">
                        Max upload filesize: 10MB <br />
                        Accepted file formats: png, jpg
                    </p>
                </v-col>
            </v-row>
        </v-container>
        <v-footer height="68">
            <v-flex px-4 py-4 text-right>
                <v-btn v-if="!loading" color="grey300" class="cancel-button" @click="closePanel">Cancel</v-btn>
                <v-btn v-if="loading" loading></v-btn>
                <v-btn v-else color="dark-blue" class="ml-4 add-course-button"  @click="updateChannel">Save</v-btn>
            </v-flex>
        </v-footer>
    </div>
</template>
<script>
    import { EventBus } from "@/event-bus.js";
    import channelAPI from "@/api/channel.js";
    import IconPicker from "@/components/admin/global/IconPicker";
    import DropZone from "@/components/global/Dropzone";

    export default {
        name: "EditChannel",
        components: {
            IconPicker,
            DropZone
        },
        props: {
            id: {
                type: String,
                default: null
            },
            params: {
                type: String,
                default: null
            }
        },
        computed: {
        s3Uploading() {
            return this.$store.getters.s3Uploading;
        },
        thumbnail() {
            return this.channel.hasOwnProperty("thumbnail")
                ? this.channel.thumbnail.data
                : null;
        },
    },
        data() {
            return {
                channel: {},
                type: "thumbnail",
                accepted: "image/jpg,image/jpeg,image/png",
                selectedIcon: null,
                currentSelection: '',
                messages: {},
                loading: false,
                successMessage: "Playlist updated successfully.",
                errorMessage: "Oops, something went wrong! Please check information is correct.",
                ChannelOptions: [
                    {
                        id: 'icon',
                        name: "Choose an icon"
                    },
                    {
                        id: 'image',
                        name: "Upload an image"
                    },
                ],
            };
        },
        mounted() {
            this.$store.dispatch("setS3Uploading", false);
            this.getChannel(this.id);
            this.setEventBus();
        },
        methods: {
            closePanel() {
                this.$emit("closePanel", {});
            },
            getChannel(id) {
                channelAPI.getChannel(id, "").then(response => {
                    this.channel = response.data.data;
                    this.selectedIcon = this.channel.icon;
                    this.currentSelection = response.data.data.thumbnailOption;
                    this.$store.dispatch("setDropzoneLoaded", true);
                });
            },
            updateChannel() {
                this.loading = true;
                if(this.channel.thumbnailOption == 'image'){
                    let file = this.$store.getters.fileDetails.name ? this.$store.getters.fileDetails : '';
                    if(this.currentSelection == 'icon') {
                        file = this.$store.getters.fileDetails;
                    }
                    channelAPI
                    .updateChannel(
                        this.id, 
                        this.channel,
                        this.$store.getters.s3Url,
                        file
                        )
                    .then(() => {
                        this.closePanel();
                        EventBus.$emit("CHANNELS_UPDATED", this.params);
                        this.$snotify.success(this.successMessage);
                        this.loading = false;
                        setTimeout(() => {
                            this.$gf.removeBackdrop();
                        },300);
                    })
                    .catch(err => {
                        this.messages = this.$gf.errorResponse(err);
                        this.$snotify.error(this.errorMessage);
                        this.loading = false;
                        if(this.messages.file) {
                            this.messages.thumbnail = this.messages.file;
                        }
                        setTimeout(() => {
                            this.$gf.removeBackdrop();
                        },300);
                    });
                }else{
                    channelAPI
                    .updateChannel(this.id, this.channel)
                    .then(() => {
                        this.closePanel();
                        EventBus.$emit("CHANNELS_UPDATED", this.params);
                        this.$snotify.success(this.successMessage);
                        this.loading = false;
                        setTimeout(() => {
                            this.$gf.removeBackdrop();
                        },300);
                    })
                    .catch(err => {
                        this.messages = this.$gf.errorResponse(err);
                        this.$snotify.error(this.errorMessage);
                        this.loading = false;
                        if(this.messages.icon) {
                            this.messages.thumbnail = this.messages.icon;
                        }
                        setTimeout(() => {
                            this.$gf.removeBackdrop();
                        },300);
                    });
                }
            },
            setEventBus() {
                EventBus.$on("ICON_SELECT", payload => {
                    this.channel.icon = payload;
                    this.selectedIcon = payload;
                });
                EventBus.$on("FILE_UPLOADED",() => {
                    this.$delete(this.messages, "s3_url");
                })
            }
        }
    };
</script>
<style scoped>
.super-size-icon {
    font-size: 200px;
}
.assetbar {
  height: calc(100% - 100px);
  overflow-y: scroll;
}

.popup-container {
  height: 100%;
}
</style>
